/** @format */

import React from 'react'
import { Tooltip, _$, Icon } from 'kpc-react'
import styled from 'styled-components'

const AlarmCallBackTooltip: React.FC<{ className?: string }> = ({ className }) => {
  return (
    <div className={className}>
      {_$('告警回调')}
      <Tooltip
        canHover
        b-content={
          <div className="callback-tooltip">
            <p>
              <i className="ping"></i>
              {_$(
                // eslint-disable-next-line max-len
                '可填写公网可访问到的 URL 或金山协作、企业微信、钉钉、飞书webhook地址，云监控将及时把告警信息推送到对应的 URL 或金山协作、企业微信、钉钉、飞书webhook地址。'
              )}
            </p>
            <p>
              <i className="ping"></i>
              {_$('告警推送失败最多重试3次，每次推送请求的超时等待时间为5秒。')}
            </p>
            <p>
              <i className="ping"></i>
              {_$(
                '注意：每个金山协作、企业微信、钉钉群机器人发送的消息不能超过20条/分钟，超过后消息会被丢弃。请您合理配置。'
              )}
            </p>
          </div>
        }
      >
        <Icon className="icontip ion-help-circled" />
      </Tooltip>
    </div>
  )
}

export default styled(AlarmCallBackTooltip)`
  .icontip {
    margin-left: 4px;
    cursor: pointer;
    font-size: 14px;
  }
`
